(function() {
    const origFetch = window.fetch;
    window.fetch = function(url, options) {
        if (url && typeof url === 'string' && url.includes('/cart/add')) {
            const subToggle = document.querySelector('input[name="Pro Sub Enable"]');
            if (options && options.body instanceof FormData) {
                if (subToggle && subToggle.checked) {
                    const variantInput = document.querySelector('input[name="Pro Sub Variant"]:checked');
                    if (variantInput) {
                        const variant = subProductJson.variants.find(v => v.id == variantInput.value);
                        if (variant && variant.selling_plan_allocations && variant.selling_plan_allocations[0]) {
                            options.body.set('selling_plan', variant.selling_plan_allocations[0].selling_plan_id);
                        }
                    }
                } else {
                    options.body.delete('selling_plan');
                }
            }
        }
        return origFetch.apply(this, arguments);
    };
})();

class ProductNewSubscription extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(e) {
        console.log('STEP 1: event fired, target:', e.target.name, e.target.checked);
        const selectedVinput = this.querySelector('input[name="Pro Sub Variant"]:checked');
        console.log('STEP 2: variant input found:', selectedVinput);
        if (!selectedVinput) {
            console.log('STEP 2 FAILED: no variant input found, exiting');
            return false;
        }
        const selectedId = selectedVinput.value;
        const selectedVariant = this.getVaraintData(selectedId);
        console.log('STEP 3: variant data:', selectedVariant ? selectedVariant.title : 'NOT FOUND');

        if (!selectedVariant) {
            console.log('STEP 3 FAILED: no variant data found, exiting');
            return false;
        }

        try {
            this.productFormUpdate(selectedVariant);
            console.log('STEP 4: productFormUpdate completed');
        } catch(err) {
            console.log('STEP 4 FAILED:', err.message);
        }

        if (e.target.name !== 'Pro Sub Enable') {
            this.updateShippingFrequency(selectedVariant);
        }
    }

    formatMoney(cents, format = "{{amount}}") {
        let value = (cents / 100).toFixed(2);
        let formatted = value;
        if (format === "{{amount_no_decimals}}") {
            formatted = Math.round(cents / 100).toString();
        } else if (format === "{{amount_with_comma_separator}}") {
            formatted = value.replace(/\./, ',');
        } else if (format === "{{amount_no_decimals_with_comma_separator}}") {
            formatted = Math.round(cents / 100).toString().replace(/\./, ',');
        } else if (format === "{{amount_with_apostrophe_separator}}") {
            formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
        } else {
            formatted = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return formatted;
    }

    updateShippingFrequency(selectedVariant) {
        const title = selectedVariant.title.toLowerCase();
        let frequency = 'every 2 months';
        if (title.includes('<25') || title.includes('< 25') || title.includes('under') || title.includes('tiny')) {
            frequency = 'every 2 months';
        } else if (title.includes('26') || title.includes('25-50') || title.includes('small')) {
            frequency = 'every 4 weeks';
        } else if (title.includes('50-100') || title.includes('50 - 100') || title.includes('large') || title.includes('medium')) {
            frequency = 'every 4 weeks';
        } else if (title.includes('100+') || title.includes('100 +') || title.includes('xl') || title.includes('extra large')) {
            frequency = 'every 3 weeks';
        }
        const freqElements = this.querySelectorAll('.js-pro-sub-ship-frequency');
        freqElements.forEach(el => {
            el.textContent = `Shipped and billed ${frequency}`;
        });
    }

    getVaraintData(variantId) {
        const selectedVariant = subProductJson.variants.find((variant) => variant.id == variantId);
        return selectedVariant || false;
    }

    productFormUpdate(selectedVariant) {
        console.log('FORM UPDATE START');
        const productForm = this.closest('.shop-product-info');
        console.log('closest .shop-product-info:', productForm);
        if (!productForm) {
            console.log('FAILED: .shop-product-info not found. Parent classes:', this.parentElement.className);
            return;
        }
        const form = productForm.querySelector('.product-form');
        console.log('.product-form:', form);
        if (!form) {
            console.log('FAILED: .product-form not found');
            return;
        }
        const inputId = form.querySelector('input[name="id"]');
        const atcButton = form.querySelector('button[type="submit"]');
        let sellingPlanInput = form.querySelector('input[name="selling_plan"]');
        const qtyInput = form.querySelector('input[name="quantity"]');
        const quantitySelected = this.querySelector('input[name="Pro Sub Quantity"]:checked');
        const subEnabled = this.querySelector('input[name="Pro Sub Enable"]');
        const hasAlloc = selectedVariant.selling_plan_allocations && selectedVariant.selling_plan_allocations[0];
        const sellingPlanId = hasAlloc ? selectedVariant.selling_plan_allocations[0].selling_plan_id : null;

        console.log('inputId:', inputId, 'atcButton:', atcButton, 'qtyInput:', qtyInput, 'subEnabled:', subEnabled.checked, 'hasAlloc:', hasAlloc);

        inputId.value = selectedVariant.id;
        if (selectedVariant.available) {
            atcButton.classList.remove('sold-out');
            atcButton.removeAttribute('disabled');
            atcButton.querySelector('.button-text').innerText = 'Add To Cart';
        } else {
            atcButton.classList.add('sold-out');
            atcButton.setAttribute('disabled', 'disabled');
            atcButton.querySelector('.button-text').innerText = 'Sold Out';
        }
        qtyInput.value = quantitySelected.value;

        if (subEnabled.checked && sellingPlanId) {
            if (!sellingPlanInput) {
                const newInput = document.createElement('input');
                newInput.type = 'hidden';
                newInput.name = 'selling_plan';
                newInput.value = sellingPlanId;
                form.appendChild(newInput);
            } else {
                sellingPlanInput.value = sellingPlanId;
            }
        } else {
            if (sellingPlanInput) {
                sellingPlanInput.remove();
            }
        }

        console.log('FORM UPDATE DONE, calling contentUpdate');
        this.contentUpdate(selectedVariant);
    }

    contentUpdate(selectedVariant) {
        console.log('CONTENT UPDATE START');
        const qtyPrices = this.querySelectorAll('.js-pro-sub-t-price');
        const comparePrices = this.querySelectorAll('.js-pro-sub-compare-price');
        const saveBadges = this.querySelectorAll('.js-pro-sub-save-badge');
        const cvPrice = selectedVariant.price;
        const hasAlloc = selectedVariant.selling_plan_allocations && selectedVariant.selling_plan_allocations[0];
        const sellingPrice = hasAlloc ? selectedVariant.selling_plan_allocations[0].price : cvPrice;
        const subEnabled = this.querySelector('input[name="Pro Sub Enable"]');
        const isSub = subEnabled.checked;

        console.log('cvPrice:', cvPrice, 'sellingPrice:', sellingPrice, 'isSub:', isSub);

        qtyPrices.forEach((qtyPrice) => {
            const qty = parseInt(qtyPrice.getAttribute('data-qty'));
            if (isSub) {
                qtyPrice.innerText = `$${this.formatMoney(sellingPrice * qty, "{{amount}}")}`;
            } else {
                qtyPrice.innerText = `$${this.formatMoney(cvPrice * qty, "{{amount}}")}`;
            }
            console.log('Updated qty', qty, 'price to', qtyPrice.innerText);
        });

        this.querySelectorAll('.pro-sub-qty').forEach((qtyEl) => {
            const qty = parseInt(qtyEl.dataset.qty);
            const totalChews = parseInt(qtyEl.dataset.totalChews);
            const perPriceEl = qtyEl.querySelector('.js-pro-sub-per-price');
            if (perPriceEl) {
                const unitPrice = isSub ? sellingPrice : cvPrice;
                const totalPrice = unitPrice * qty;
                const perDay = (totalPrice / totalChews / 100).toFixed(2);
                perPriceEl.innerText = `${totalChews} Chews / $${perDay} per day`;
                console.log('Updated per-day for qty', qty, ':', perPriceEl.innerText);
            }
        });

        comparePrices.forEach((compareEl) => {
            const tierCompare = parseInt(compareEl.getAttribute('data-compare'));
            compareEl.innerText = `$${this.formatMoney(tierCompare, "{{amount}}")}`;
            compareEl.style.display = '';
        });

        saveBadges.forEach((badge) => {
            const qty = parseInt(badge.getAttribute('data-qty'));
            const compareEl = this.querySelector(`.js-pro-sub-compare-price[data-qty="${qty}"]`);
            const tierCompare = compareEl ? parseInt(compareEl.getAttribute('data-compare')) : 0;
            const totalActive = isSub ? sellingPrice * qty : cvPrice * qty;
            if (tierCompare > totalActive) {
                const savePercent = Math.round(((tierCompare - totalActive) / tierCompare) * 100);
                badge.innerText = `Save ${savePercent}%`;
                badge.style.display = '';
            } else {
                badge.style.display = 'none';
            }
        });

        console.log('CONTENT UPDATE DONE');
    }
}

customElements.define('product-new-subscription', ProductNewSubscription);